var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAssuredSale = function SvgAssuredSale(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6551 40.0531C36.8161 40.0531 41 35.8693 41 30.7083C41 25.5473 36.8161 21.3635 31.6551 21.3635C26.4941 21.3635 22.3103 25.5473 22.3103 30.7083C22.3103 35.8693 26.4941 40.0531 31.6551 40.0531Z",
    fill: "#73E7FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50479 31.6672C12.7912 37.2549 18.5009 39.5039 19.8085 39.9572C20.1746 40.088 20.5669 40.088 20.933 39.9572C22.2406 39.5039 27.9504 37.2549 31.2367 31.6672C32.8494 28.9213 33.4683 25.2862 33.6688 22.1131C33.8693 18.9139 33.6514 16.0634 33.5294 14.7994C33.4509 13.9626 32.8146 13.3436 32.0562 13.1867C31.0101 12.9688 28.9441 12.4806 27.1658 11.6787C25.2219 10.8069 22.5544 9.07221 21.4125 8.31382C20.7848 7.89539 19.9654 7.89539 19.3378 8.31382C18.1958 9.07221 15.5284 10.7982 13.5844 11.6787C11.7974 12.4806 9.73144 12.9688 8.69409 13.1867C7.93569 13.3436 7.29934 13.9626 7.22088 14.7994C7.09884 16.0634 6.88091 18.9139 7.08141 22.1131C7.2819 25.2862 7.89211 28.9213 9.51351 31.6672H9.50479Z",
    fill: "#866EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4101 29.4007C19.4163 29.4007 18.5882 29.2525 17.9257 28.9648C17.2632 28.6772 16.7663 28.2675 16.435 27.727C16.1038 27.1953 15.9294 26.5676 15.9294 25.8441H18.1698C18.1698 26.1318 18.2482 26.3933 18.3964 26.6461C18.5446 26.8989 18.7887 27.0907 19.1287 27.2388C19.4599 27.387 19.887 27.4568 20.4101 27.4568C21.0987 27.4568 21.6305 27.3347 22.0053 27.0907C22.3714 26.8466 22.5632 26.524 22.5632 26.1143C22.5632 25.7569 22.4063 25.4693 22.0925 25.2426C21.7787 25.016 21.2731 24.8678 20.5844 24.7893L19.8086 24.7283C18.7189 24.6237 17.8559 24.3012 17.2196 23.7433C16.5832 23.1941 16.2607 22.4095 16.2607 21.3896C16.2607 20.6922 16.4176 20.0995 16.7314 19.6287C17.0452 19.158 17.4985 18.8006 18.0826 18.5652C18.6754 18.3299 19.3815 18.2078 20.2009 18.2078C21.0813 18.2078 21.8223 18.3473 22.4238 18.6175C23.0252 18.8878 23.4785 19.2888 23.7836 19.8031C24.0975 20.3174 24.2456 20.9538 24.2456 21.6947H22.0053C22.0053 21.3983 21.9356 21.1368 21.7961 20.9102C21.6566 20.6835 21.4561 20.5005 21.1946 20.3523C20.9331 20.2128 20.5931 20.1343 20.1922 20.1343C19.8347 20.1343 19.5296 20.1866 19.2768 20.2825C19.024 20.3871 18.8323 20.5266 18.7015 20.7184C18.5708 20.9102 18.501 21.1281 18.501 21.3809C18.501 21.6947 18.6143 21.9737 18.8497 22.2265C19.0851 22.4793 19.4686 22.6275 20.0091 22.6885L20.7849 22.7495C22.0053 22.8541 22.9817 23.1766 23.7052 23.7345C24.4374 24.2924 24.8035 25.077 24.8035 26.0969C24.8035 26.7943 24.6292 27.387 24.2892 27.8752C23.9405 28.3634 23.4437 28.7295 22.7899 28.991C22.1361 29.2438 21.3428 29.3746 20.4101 29.3746V29.4007ZM19.2681 18.9662V16.7433H21.2644V18.9662H19.2681ZM19.3291 31.3011V29.0782H21.3254V31.3011H19.3291Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.695 21.5988C33.0412 21.4506 32.3612 21.3722 31.6551 21.3722C26.4946 21.3722 22.3103 25.5564 22.3103 30.717C22.3103 33.4891 23.522 35.9648 25.4398 37.6733C27.4186 36.357 29.624 34.4218 31.2367 31.6672C32.8494 28.9213 33.4683 25.2862 33.6688 22.1132C33.6775 21.9388 33.6862 21.7732 33.695 21.6076V21.5988Z",
    fill: "url(#paint0_linear_11600_47971)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6529 33.8813C30.4785 33.8813 30.3129 33.8116 30.1909 33.6896L27.1486 30.6473C26.8958 30.3945 26.8958 29.976 27.1486 29.7232C27.4014 29.4704 27.8198 29.4704 28.0726 29.7232L30.6529 32.3035L35.2381 27.7183C35.4909 27.4655 35.9094 27.4655 36.1622 27.7183C36.415 27.9711 36.415 28.3895 36.1622 28.6423L31.1149 33.6896C30.9929 33.8116 30.8272 33.8813 30.6529 33.8813Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11600_47971",
    x1: 31.8033,
    y1: 31.8764,
    x2: 24.5419,
    y2: 24.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5039FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5039FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5039FF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5039FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5039FF",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5039FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5039FF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5039FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5039FF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5039FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAssuredSale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Assured_sale.c8a3c0f4e602f9a45c46f337f6a2b029.svg";